// extracted by mini-css-extract-plugin
export default {"popupImage":"popupImage--aCCZZ","fade-in":"fade-in--DAcNs","downloadCta":"downloadCta--cU09d"};